<template>
  <div id="dashboard">
    <div class="background-container">
      <div id="top-section">
        <ZoneSelector v-if="!weatherZonesStacked" />
        <Alert :alert="snow_report.Alert" :alertBtn="snow_report.StormRadar" :alertBtnText="snow_report.StormRadarButtonText" />

        <div class="full-width-container dashboard-block" v-if="showNews">
          <News :news="snow_report.News" :newsTitle="newsTitle" />
        </div>

        <div id="dashboard-blocks" >
          <div id="main-col">

            <Weather
              class="dashboard-block"
              :class="{ 'hide-tablet': activeDashboardSection !== 'Weather'}"
              v-if="!weatherZonesStacked"
            />

            <WeatherStacked
              class="dashboard-block"
              :class="{ 'hide-tablet': activeDashboardSection !== 'Weather'}"
              v-if="weatherZonesStacked"
            />

            <snowfallChart class="dashboard-block" v-if="showSnowfallChart" />

            <TrailsOverview
              class="dashboard-block"
              :snow_report="snow_report"
              :class="{ 'hide-tablet': activeDashboardSection !== 'Trails'}"
              v-if="!showSnowfallChart"
            />
          </div>
          <div id="side-col">
            <Webcams
              class="show-tablet-landscape show-tablet"
              :class="{ 'show-tablet-override': activeDashboardSection !== 'Cams'}"
            />
            <WebcamsHooper class="hide-tablet-landscape" />
          </div>

          <TrailsOverview
            class="dashboard-block"
            :snow_report="snow_report"
            :class="{ 'hide-tablet': activeDashboardSection !== 'Trails'}"
            v-if="showSnowfallChart"
          />
        </div>

        <div :class="quickLinksPromoClass">
          <QuickLinks class="dashboard-block col" />
          <PromoBanner class="dashboard-block no-padding col" />
        </div>
      </div>
    </div>

    <div class="dashboard-block">
      <SectionNavigation />
      <MountainAreaNavigation />
    </div>

    <transition name="fade">
      <Legend />
    </transition>

    <Sections class="dashboard-block plain-block" />

  </div>
</template>

<script>
import { mapState } from 'vuex';
import ZoneSelector from '@/components/ZoneSelector.vue';
import Weather from '@/components/Weather.vue';
import WeatherStacked from '@/components/WeatherStacked.vue';
import Alert from '@/components/Alert.vue';
import News from '@/components/News.vue';
import SnowfallChart from '@/components/SnowfallChart.vue';
import TrailsOverview from '@/components/TrailsOverview.vue';
import Webcams from '@/components/Webcams.vue';
import WebcamsHooper from '@/components/WebcamsHooper.vue';
import PromoBanner from '@/components/PromoBanner.vue';
import QuickLinks from '@/components/QuickLinks.vue';
import MountainAreaNavigation from '@/components/MountainAreas/Navigation.vue';
import Legend from '@/components/MountainAreas/Legend.vue';
import SectionNavigation from '@/components/SectionNavigation.vue';
import Sections from '@/components/Sections.vue';

export default {
  name: 'Dashboard',
  components: {
    Alert,
    News,
    ZoneSelector,
    Weather,
    WeatherStacked,
    SnowfallChart,
    TrailsOverview,
    Webcams, // Mobile
    WebcamsHooper,
    PromoBanner,
    QuickLinks,
    Legend,
    SectionNavigation,
    MountainAreaNavigation,
    Sections,
  },
  computed: {
    ...mapState(['snow_report', 'activeDashboardSection', 'quickLinks', 'promoBanner', 'weatherZonesStacked', 'newsAtTop', 'newsTitle', 'showSnowfallChart']),
    quickLinksPromoClass() {
      if (this.quickLinks && this.promoBanner) {
        return 'flex-grid flex-quicklinks-promo';
      }
      return '';
    },
    newsPresent() {
      return this.snow_report.News !== '--';
    },
    showNews() {
      return this.newsPresent && this.newsAtTop;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/site';

#dashboard {
  #top-section {
    @media (min-width: $tablet) {
      margin: 20px 60px 0;
    }
  }
  #dashboard-blocks {
    display: flex;
    flex-flow: column;
    flex-direction: column;
    width: 100%;

    #main-col {
      width: 100%;
    }
    #side-col {
      background-color: $white;
      margin-bottom: 30px;
      width: 100%;
      @media (min-width: $tablet) {
        box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }

  // For when both of these are showing
  .flex-quicklinks-promo {
    align-items: normal;
    .quick-links-container {
      background: $quicklinks-background;
      align-self: auto;
      flex-basis: 100%;
      padding: 25px 30px;
      @media (max-width: $tablet-landscape) {
        margin-right: 0;
      }
      @media (min-width: $tablet-landscape) {
        flex-basis: 30%;
      }
    }
    .promo-banner-container {
      flex-basis: 100%;
      @media (min-width: $tablet-landscape) {
        flex-basis: 68.5%;
      }
    }
  }

  .dashboard-block {
    background-color: $white;
    margin-bottom: 30px;
    padding: 20px;
    width: 100%;
    @media (min-width: $tablet) {
      box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 35px;
    }
    &.plain-block {
      background-color: $body-bg;
      box-shadow: 0 0 0 0;
    }
    &.no-padding {
      padding: 0;
    }
  }
}

@media (min-width: $tablet-landscape) {
  #dashboard {
    #dashboard-blocks {
      flex-flow: wrap;
      #main-col {
        margin-right: 2%;
        width: 78%;
      }

      #side-col {
        width: 20%;
      }
    }
    .dashboard-block { visibility: visible; }
  }
}
</style>
